import getCategories from './util/getCategories'
import getSkincareCollections from './util/getSkincareCollections'


const getNavStructureDropdown = ({ root, structure }) => {
  const isSkincare = root === 'skincare'

  return structure.map(({ pageTitle, url, name, children, productsQuery: { gender } }) => {
    const categories = getCategories({ routes: children })
    const newStructureItem = {
      type: 'nav',
      nav: [
        { title: pageTitle, to: url, name, lg: true },
      ],
    }

    if (isSkincare) {
      const collectionsItem = getSkincareCollections({ gender })

      newStructureItem.nav.push(collectionsItem)
    }

    newStructureItem.nav.push(...categories)

    return newStructureItem
  })
}


export default getNavStructureDropdown
